// Modelo Compañia para administrador.
export default class Company {
    id=""
    code=""
    name=""
    status=true
}



// WEBPACK FOOTER //
// ./src/model/Company.js